import { FILTER_TAGS } from '@/domain/images';

/** Wound detection filters (excludes maturation). Fixed length — do not filter dynamically. */
export const WOUND_DETECTION_FILTER_TAGS = FILTER_TAGS.filter(
    (filter) => filter.tag !== 'maturation_tag'
);

export const WOUND_FILTER_BY_TAG = Object.fromEntries(
    WOUND_DETECTION_FILTER_TAGS.map((entry) => [entry.tag, entry])
) as Record<
    'all' | 'wound' | 'healing_wound' | 'small' | 'medium' | 'large',
    (typeof WOUND_DETECTION_FILTER_TAGS)[number]
>;

export function getWoundFilterForTag(
    tag: string
): (typeof WOUND_DETECTION_FILTER_TAGS)[number]['filter'] {
    return (WOUND_FILTER_BY_TAG[tag as keyof typeof WOUND_FILTER_BY_TAG] ?? WOUND_FILTER_BY_TAG.all)
        .filter;
}
